export default function replacePlaceholderValue(placeholder) {
  /**
   * 1. Replace spaces with underscores
   * 2. Replace special characters with empty string (i.e: no special characters allowed)
   */
  return placeholder.replace(/ /g, '_').replace(/[^a-zA-Z\d\s:_]/g, '');
}
